import { detachWrite, FirestoreWriteOp } from '@griply/services';
import {
  DocumentData,
  DocumentReference,
  serverTimestamp,
  UpdateData,
  updateDoc,
} from 'firebase/firestore';
import { logFirestoreWriteError } from 'shared/services/error-tracking';

// Detached: a write promise never settles offline, and a rejection nobody handles reaches Sentry untagged.
export const updateDocWithTimestamp = <Data extends DocumentData>(
  ref: DocumentReference,
  data: UpdateData<Data>,
  op: FirestoreWriteOp,
) =>
  detachWrite(
    updateDoc(ref, {
      ...data,
      updatedAt: serverTimestamp(),
    }),
    (error) => logFirestoreWriteError({ op, error, docPath: ref.path }),
  );
